import { render, staticRenderFns } from "./DictBadge.vue?vue&type=template&id=1b69cc1d&scoped=true"
import script from "./DictBadge.vue?vue&type=script&lang=js"
export * from "./DictBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69cc1d",
  null
  
)

export default component.exports